__turbopack_context__.v({
  "beam": "BorderBeam-module-scss-module__yb7Kza__beam",
  "border-beam": "BorderBeam-module-scss-module__yb7Kza__border-beam",
});
